<script type="text/javascript">
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import Icon from "../Icons/Icon";

	import MySvelteTable from "../AlertList/MySvelteTable.svelte";
	import Datepicker from "svelte-calendar";
	import Radio from '@smui/radio';
	import FormField from '@smui/form-field';
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import IMOCounter from '../IMOCounter.svelte';
	import HelperText from "@smui/textfield/helper-text/index";
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Button, {Label, Group, GroupItem, Icon as ButtonIcon} from '@smui/button';
	import Fab, { Label as FabLabel, Icon as FabIcon } from "@smui/fab";

	import Card from '@smui/card';

	import '../LayerList/LayerList.scss';
	import LayerListSwitch from '../LayerList/LayerListSwitch.svelte';

	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";

	import MapStore from "../../Map/Store";
	import InfoCardStore from "../InfoCard/Store";
	import VesselHistoryStore from "./Store";

	import Spinner from "../Spinner/Spinner.svelte";

	import IdentityHelper from "../../Branding/IdentityHelper";
	import User from "../../Branding/User";
	import Feature from "../../Branding/Feature";

	import GeoHelper from "../../Helpers/GeoHelper";
	import StringHelper from "../../Helpers/StringHelper";
	import FilterHelper from "../../Helpers/FilterHelper";
	import ValidationHelper from "../../Helpers/ValidationHelper";
	import InputHelper from "../../Helpers/InputHelper";
	import { getTwoYearsAgoFudge } from "../../Helpers/Misc/timeHelper";

	import LoadState from "../../Enums/LoadState";
	import DateDialect from "../../Enums/DateDialect";
	import DateRestriction from "../../Enums/DateRestriction";

	import MapLayer from "../../Map/Enums/MapLayer";
	import MapViewType from "../../Map/Enums/MapViewType";
	import MapDataSource from "../../Map/Enums/MapDataSource";
	import MapLayerManager from "../../Map/MapLayerManager";

	import API from "../../API/API";

	import HeatmapKey from "../HeatmapKey/HeatmapKey.svelte";
	import DownloadResultsButton from "./DownloadResultsButton.svelte";
	import InvestigateDataGaps from "./InvestigateDataGaps.svelte";
	import TimeSlider from "../TimeSlider/TimeSlider.svelte";
	import TimeSliderData from "../TimeSlider/TimeSliderData";

	import DownsampleRate from "../../Enums/DownsampleRate";
	import "./VesselHistory.scss";

	import moment from "moment";

	import Vessel from "../../Models/Vessel";
	import VesselIDType from '../../Models/Enums/VesselIDType';
	import VesselProperty from '../../Models/Enums/VesselProperty';
	import VesselSpireDataPropertyMap from '../../Models/Enums/VesselSpireDataPropertyMap';
	import AlertType from "../../Alerts/AlertType.js";
	import AlertsStore from "../../Alerts/Store.js"
	import KeyComponent from "../Key/KeyComponent.svelte";

	import AuthStore from '../../Auth/Store';
	import DistanceUtil from "../MeasureTool/DistanceUtil";
	import InvestigateMergedPoints from "./InvestigateMergedPoints.svelte";
	import Analytics from "../../Analytics/Analytics";
import VesselKeyComponent from "../Key/VesselKeyComponent.svelte";
	// import vessel from '../../Models/Vessel.js';

	const MAX_INPUTS = 100;
	const MAX_INPUTS_FOR_ALL = 5;

	const today = new Date();
	let twoYearsAgo = getTwoYearsAgoFudge();

	let downsampling = VesselHistoryStore.query.downsampling; //DownsampleRate.DAILY;

	let state = VesselHistoryStore.meta.loadState;
	let progress = VesselHistoryStore.meta.progress;
	let error = VesselHistoryStore.meta.error;
	let lastUpdated = VesselHistoryStore.meta.lastUpdated;

	// What's the best way to make showLoadingCard / VesselHistoryStore.helpers.shouldShowLoadingCard() reactive?
	let showLoadingCard = false;
	let showResults = false;
	$: {
		$lastUpdated;
		// showLoadingCard = VesselHistoryStore.helpers.shouldShowLoadingCard();

		showLoadingCard = false;
		const spireIds = Object.keys(spireIdProgressData);
		for (let i = 0; i < spireIds.length; i++) {
			const spireId = spireIds[i];
			if (spireIdProgressData[spireId].loadState !== LoadState.LOADED) {
				showLoadingCard = true;
				break;
			}
		}

		showResults = false;
		if (spireIds.length === 0) {
			if ($state === LoadState.LOADED) {
				showResults = true;
			}
		}
		else {
			showResults = true;
			for (let i = 0; i < spireIds.length; i++) {
				const spireId = spireIds[i];
				if (spireIdProgressData[spireId].loadState !== LoadState.LOADED) {
					showResults = false;
					break;
				}
			}
		}

	}

	const map = MapStore.mapbox.instance;

	let fetchButton;
	let fromFormattedSelected, toFormattedSelected;
	let imommsiTextAreaValue = VesselHistoryStore.query.inputString;
	let imommsiInputValid = VesselHistoryStore.query.inputValid;
	let imommsiInputLength = VesselHistoryStore.query.inputLength;
	let showValidationText = VesselHistoryStore.query.inputError;

	const fromDateTimeStore = VesselHistoryStore.query.fromDatetime;
	const toDateTimeStore = VesselHistoryStore.query.toDatetime;
	const invalidInputsStore = VesselHistoryStore.query.invalidInputs;

	let timeSliderData = VesselHistoryStore.vesselGroup.timeSliderData;
	$: {
		$downsampling;
		$toDateTimeStore;
		$fromDateTimeStore;
		updateTimeSliderMinMax();
	}
	let updateTimeSliderMinMax = () => {
		let minDate = moment($fromDateTimeStore).startOf("day");
		let maxDate = moment($toDateTimeStore).add(1, "day");
		timeSliderData.min.set(minDate);
		timeSliderData.max.set(maxDate);
		timeSliderData.step.set(($downsampling === DownsampleRate.DAILY)?86400:300);
		timeSliderData.value.set(get(timeSliderData.max));
		// console.log("TimeSliderData", get(timeSliderData.min), get(timeSliderData.max));
	};

	$: queryIsValid = $imommsiInputValid && $imommsiInputLength <= MAX_INPUTS;

	let startAutoContinueCountdown = (obj, seconds) => {
		obj.autoContinueCounter.set(seconds + 1);
		//obj.autoContinueInterval = null;
		obj.autoContinueInterval = setInterval(()=>{
			obj.autoContinueCounter.set(get(obj.autoContinueCounter) - 1);
			$lastUpdated = Date.now();
			if (get(obj.autoContinueCounter) <= 0) {
				stopAutoContinueCountdown(obj);
				//continueApiRequest();
				startRequest(obj);
			}
		}, 1000);
	};
	let stopAutoContinueCountdown = (obj) => {
		if (obj.autoContinueInterval !== null) {
			obj.autoContinueCounter.set(0);
			clearInterval(obj.autoContinueInterval);
			obj.autoContinueInterval = null;
		}
	};
	let stopAllAutoContinues = () => {
		let spireIds = Object.keys(spireIdProgressData)
		for (let spireId in spireIds) {
			stopAutoContinueCountdown(spireIdProgressData[spireIds[spireId]]);
		}
	};

	
	onMount(() => {
		VesselHistoryStore.actions.initMap( MapStore.helpers.getMap() );
		VesselHistoryStore.vesselGroup.uniqidType = VesselProperty.SPIRE_ID;

		InfoCardStore.actions.close();

		MapStore.actions.setViewType(MapViewType.FLEET_HISTORY);
		console.log("Activate fleet mode");
		console.log("Stored From Time", get(VesselHistoryStore.query.fromDatetime));

		//Sync store to UI
		const storedFromTime = get(fromDateTimeStore);
		const storedToTime = get(toDateTimeStore);

		const storedImos = get(VesselHistoryStore.query.vesselInputs);
		if (storedImos.length > 0) {
			let longString = "";
			storedImos.forEach(imo => (longString = longString + " " + imo));
			$imommsiTextAreaValue = longString.trim();
			$imommsiInputLength = storedImos.length;
			$imommsiInputValid = true;
		}

		//Debug, to remove
		fromDateTimeStore.subscribe(v => "From set to: " + v);
		toDateTimeStore.subscribe(v => "To set to: " + v);

		return () => {

		};
	});
	onDestroy(()=>{
		VesselHistoryStore.actions.deinitMap();
	});



	//#region data

	let historicVessels = VesselHistoryStore.vesselGroup.vessels;

	let heatmapDataPoints = VesselHistoryStore.results.points.raw;
	let heatmapDataLines = VesselHistoryStore.results.lines.raw;

	let heatmapDataPointsFiltered = VesselHistoryStore.results.points.filtered;
	let heatmapDataLinesFiltered = VesselHistoryStore.results.lines.filtered;

	let mergedPoints = VesselHistoryStore.results.mergedPoints.raw;

	let layerHeatmap = VesselHistoryStore.filters.layers.heatmap.enabled;
	let layerPositions = VesselHistoryStore.filters.layers.positions.enabled;
	let layerJourneys = VesselHistoryStore.filters.layers.journeys.enabled;
	let layerVessels = VesselHistoryStore.filters.layers.vessels.enabled;

	let filterString = VesselHistoryStore.filters.filterString;

	let resultsTableRows = VesselHistoryStore.results.tableData.raw;
	let resultsTableRowsFiltered = VesselHistoryStore.results.tableData.filtered;
	let counter = 0;
	let counterTotal = 1;

	let investigate;
	let investigateMerged;
	let spireIdProgressData = {};

	let onCounterChanged = () => {
		console.log("counter", counter, "out of", counterTotal);
		$progress = Math.ceil((parseFloat(counter) / parseFloat(counterTotal)) * 100)
		if (counter === counterTotal) {
			$state = LoadState.LOADED;
			$error = "";
			updateFilter();
			// updateVessels();
			updateMapWithData();
			updateExtent();
		}
		$lastUpdated = Date.now();
	};

	let updateExtent = () => {
		MapStore.helpers.zoomToFeaturesArray([
			...$heatmapDataLinesFiltered,
			...$historicVessels.map((vessel) => { return vessel.currentFeature; })
		]);
	}
	let pollProgress;
	let startRequest = (requestData) => {
		// if (requestData.autoContinueInterval !== null) {
		// 	requestData.autoContinueCounter.set(0);
		// 	clearInterval(requestData.autoContinueInterval);
		// 	requestData.autoContinueInterval = null;
		// }
		stopAutoContinueCountdown(requestData);
		requestData.loadState = LoadState.LOADING;
		requestData.loadProgress = 0;
		requestData.error = "";
		requestData.page = 1;
		requestData.responseString = "";
		requestData.startTime = Math.round(Date.now()/1000);
		API.request(requestData.fullUrl + "&restart_if_not_finished=true")
			.then((response) => {
				console.log("startRequest", response);
			})
			.catch((e) => {
				console.error("startRequest error", e);
			});

		spireIdProgressData = spireIdProgressData;
		$lastUpdated = Date.now();

		((requestData) => {
			requestData.timeout = setTimeout(() => {
				pollProgress(requestData);
			}, 5000);
		})(requestData)
	};
	pollProgress = (requestData) => {
		API.request(requestData.fullUrl + "&page=" + requestData.page)
			.then((response) => {
				console.log('pollProgress', response);
				if (response.state === "finished") {
					clearTimeout(requestData.timeout);
					requestData.timeout = null;

					requestData.responseString += response.data.content;

					if (requestData.page >= response.data.pagination.total) {
						// We should now have all the data.
						const all = JSON.parse(requestData.responseString);
						console.log(all);

						onPointsCompleteForVessel(requestData.vessel, all);
						updateFilter();
						updateMapWithData();
						requestData.loadState = LoadState.LOADED;
						requestData.loadProgress = 1;

						spireIdProgressData = spireIdProgressData;
						$lastUpdated = Date.now();

						counter++;
						onCounterChanged();
						// vessel.generateHistoricPath(all);
					}
					else {
						// if (response.data.pagination.total > 1) { }
						requestData.page++;
						pollProgress(requestData);
					}
				}
				else if (response.state === "error") {
					console.error(response.message);
					requestData.error = "Error occured on data provider. "; // response.message; // We appreciate your patience as we resolve this issue.
					clearTimeout(requestData.timeout);
					requestData.timeout = null;
					requestData.loadState = LoadState.INIT;
					// requestData.loadProgress = 0;

					startAutoContinueCountdown(requestData, 5);

					spireIdProgressData = spireIdProgressData;

					$lastUpdated = Date.now();
				}
				else {
					if (response.state === "progress") {
						requestData.loadProgress = response.progress;

						spireIdProgressData = spireIdProgressData;
						$lastUpdated = Date.now();
					}
					// If we've been doing this for 15 minutes, we should error out.
					const elapsedSeconds = Math.floor(Date.now()/1000) - requestData.startTime;
					console.log(requestData.spireId, "elapsedSeconds", elapsedSeconds);
					if (elapsedSeconds >= 900) {
						console.error("request timed out");
						requestData.error = "Request timed out.";
						clearTimeout(requestData.timeout);
						requestData.timeout = null;
						requestData.loadState = LoadState.INIT;
						requestData.loadProgress = 0;

						startAutoContinueCountdown(requestData, 5);

						spireIdProgressData = spireIdProgressData;
						$lastUpdated = Date.now();
					}
					else {
						requestData.timeout = setTimeout(() => {
							pollProgress(requestData);
						}, 5000);
					}
				}
			})
			.catch((e)=>{
				console.error('pollProgress error', e);
				clearTimeout(requestData.timeout);
				requestData.timeout = null;

				startAutoContinueCountdown(requestData, 5);
			});
	};

	let startApiRequestNew = async () => 
	{
		
		// onCounterChanged();

		// const from = "2019-08-24T00:00:00";
		// const to   = "2020-08-24T23:59:58";
		const fromSelected = get(VesselHistoryStore.query.fromDatetime);
		const toSelected = get(VesselHistoryStore.query.toDatetime);
		const from = new Date(Date.parse(fromSelected)).toISOString();
		const to = new Date(Date.parse(toSelected) + 86399999).toISOString(); // inclusive date
		let downsample = 86400;
		// const uniqid = ""+Math.round(Math.random()*1000000);

		const inputsArray = get(VesselHistoryStore.query.vesselInputs);
		console.log(inputsArray);
		const countInputs = inputsArray.length;
		const inputsString = inputsArray.join(",");

		Analytics.event("query", { category: "Vessel History", username: get(AuthStore.userInfo).username, inputType: $inputType, inputs: inputsArray, from: from, to:to });

		resetApiRequest();
		$state = LoadState.LOADING;

		$progress = 0;
		$lastUpdated = Date.now();

		counter = 0;
		counterTotal = countInputs + 1;

		//let imos = ["9439199", "9267417", "9368883"];
		let data = null;
		try {
			data = await API.request("vessels?" + $inputType + "=" + inputsString);
		}
		catch(e) {
			$error = e.data.detail;
			$state = LoadState.INIT;
			$lastUpdated = Date.now();
			return;
		}

		let rawVessels = [];
		for (var i = 0; i < data.data.length; i++) {
			data.data[i].properties[VesselSpireDataPropertyMap[VesselProperty.SPIRE_ID]] = data.data[i].properties.id;

			let vessel = new Vessel(data.data[i], AlertType.NONE, AlertType.DEFAULT_CATEGORY_NAME, VesselHistoryStore.vesselGroup, VesselSpireDataPropertyMap);
			vessel.setUniqIdType(VesselProperty.SPIRE_ID);
			rawVessels.push(vessel);
		}
		rawVessels.sort((a, b)=>{ return a.timestamp < b.timestamp; });
		//console.log("rawVessels", rawVessels);

		let vessels;
		if ($inputType === VesselIDType.IMO) {
			let groupByIMO = {};
			let additionsBecauseOfMutualTime = [];
			
			for(let i = 0; i < rawVessels.length; i++) {
				let createdTime = moment(Date.parse(rawVessels[i].createdAt));
				let lastTimestamp = moment(Date.parse(rawVessels[i].timestamp));

				if (createdTime <= moment(to) && lastTimestamp >= moment(from))
				{
					if (typeof groupByIMO[rawVessels[i].imo] === "undefined") {
						groupByIMO[rawVessels[i].imo] = rawVessels[i];
					}
					else {
						groupByIMO[rawVessels[i].imo].addPreviousVersion(rawVessels[i]);
						rawVessels[i].addPreviousVersion( groupByIMO[rawVessels[i].imo] );
						additionsBecauseOfMutualTime.push(rawVessels[i]);
					}
				}
			}
			// console.log("additionsBecauseOfMutualTime", additionsBecauseOfMutualTime);
			vessels = [
				...Object.values(groupByIMO),
				...additionsBecauseOfMutualTime
			];
		}
		else {
			vessels = [...rawVessels];
		}
		// console.log("vessels", vessels);

		for(let i = 0; i < vessels.length; i++) {

			const spireId = vessels[i].spireId;

			const vesselRequestData = {
				index: i,
				vessel: vessels[i],
				fullUrl: ("vessels/" + spireId + "/positions-async" +
							"?timestamp_after=" + from +
							"&timestamp_before=" + to +
							(($downsampling === DownsampleRate.DAILY)?("&downsample=" + downsample):"")
						 ),
				spireId: vessels[i].spireId,
				startTime: Math.round(Date.now()/1000),
				page: 1,
				timeout: null,
				responseString: "",
				error: "",
				loadState: LoadState.INIT,
				loadProgress: 0,
				autoContinueCounter: writable(0),
				autoContinueInterval: null
			};
			spireIdProgressData[vessels[i].spireId] = vesselRequestData;

			startRequest(vesselRequestData);
		}

		VesselHistoryStore.vesselGroup.vessels.set(vessels);
		counterTotal = Object.keys(spireIdProgressData).length + 1;
		counter++;
		onCounterChanged();

	};

	let onPointsCompleteForVessel = (vessel, points) => {
		for (var i = 0; i < points.length; i++) {
			let feature = points[i];
			feature.properties.imo = vessel.imo;
			feature.properties.name = vessel.name;
			feature.properties.spireId = vessel.spireId;
			feature.properties.iconImage = (typeof feature.properties.course !== "undefined") ? "path-triangle-isosceles" : "dot-11";
		}
		// If the results contain no points, it doesn't have any "history" in the time period and should be removed.
		if (points.length === 0) {
			let allVessels = get(VesselHistoryStore.vesselGroup.vessels);
			let index = allVessels.indexOf(vessel);
			if (index >= 0) {
				let v = allVessels[index];
				allVessels.splice(index, 1);
				VesselHistoryStore.vesselGroup.vessels.set(allVessels);
				console.log('removed vessel result', vessel.imo, vessel.mmsi, v);
				$lastUpdated = Date.now();
				return;
			}
		}
		// Sort points
		points.sort((a, b) => {
			a = Date.parse(a.properties.timestamp);
			b = Date.parse(b.properties.timestamp);
			return a > b;
		});

		console.log('points for imo/mmsi', vessel.imo, vessel.mmsi, points);
		vessel.generateHistoricPath(points);

		// add to table
		$resultsTableRows = [
			...$resultsTableRows,
			{
				imo: vessel.imo,
				name: vessel.name,
				mmsi: vessel.mmsi,
				shipType: vessel.classification, //.shipType,
				spireId: vessel.spireId,

				vessel: vessel,
				selected: vessel.selected
				//,
				//selected: spireIdProgressData[spireId].vessel.selected
			}
		];

		addLinesAndPointsForVessel(vessel);
		
		$lastUpdated = Date.now();
	};

	let removeLinesAndPointsForAllVessels = () => {
		$heatmapDataPoints = [];
		$heatmapDataLines = [];
		$heatmapDataPointsFiltered = [];
		$heatmapDataLinesFiltered = [];

		$mergedPoints = []; 
	};

	let addLinesAndPointsForVessel = (vessel) => {

		let points = vessel.historicPath.points;

		let lineCoords = [];
		const optimiseReallyCloseTogether = true;
		if (optimiseReallyCloseTogether) {

			let doPushPoint = (point, i) => {
				
				const latestPushedPoint = ($heatmapDataPoints.length > 0)
					? $heatmapDataPoints[$heatmapDataPoints.length - 1]
					: null;

				$heatmapDataPoints.push(point);

				const prevPoint = points[i-1];
				if (latestPushedPoint && typeof latestPushedPoint.properties.countPoints !== "undefined" && prevPoint) {
					latestPushedPoint.properties.endTime = prevPoint.properties.timestamp;
				}
			};
			// add to whole dataset
			for (var i = 0; i < points.length; i++) {
				const point = points[i];
				if (i == 0) {
					doPushPoint(point, i);
				} 
				else if (i == points.length - 1) {
					doPushPoint(point, i);
				} 
				else {
					let latestPoint = $heatmapDataPoints[$heatmapDataPoints.length-1]; 
					let distSq = DistanceUtil.distanceSquared(latestPoint.geometry.coordinates[0], latestPoint.geometry.coordinates[1], point.geometry.coordinates[0], point.geometry.coordinates[1]);
					if (distSq > 0.0000000001) {
						// console.log(i, pointCoords, distSq);
						doPushPoint(point, i);
					}
					else {
						if (typeof latestPoint.properties.countPoints === "undefined") {
							latestPoint.properties.countPoints = 1;
							latestPoint.properties.startTime = latestPoint.properties.timestamp;
							// mergedPoints.push(latestPoint);
							$mergedPoints = [ ...$mergedPoints, latestPoint ];
						}
						latestPoint.properties.countPoints++;
					}
				}
			}

			// add lines data
			
			for (var i = 0; i < points.length; i++) {
				const pointCoords = points[i].geometry.coordinates;
				if (i == 0 || i == points.length - 1) {
					lineCoords.push(pointCoords);
				}
				else {
					let distSq = DistanceUtil.distanceSquared(lineCoords[lineCoords.length-1][0], lineCoords[lineCoords.length-1][1], pointCoords[0], pointCoords[1]);
					if (distSq > 0.0000000001) {
						// console.log(i, pointCoords, distSq);
						lineCoords.push(pointCoords);
					}
				}
			}			
		}
		else {
			// add to whole dataset
			for (var i = 0; i < points.length; i++) {
				$heatmapDataPoints.push(points[i]);
			}

			// add lines data
			for (var i = 0; i < points.length; i++) {
				const pointCoords = points[i].geometry.coordinates;
				lineCoords.push(pointCoords);
			}
		}

		
		let coordsLineFeature = GeoHelper.fixLineWrapAround({
			type: "Feature",
			properties: {
				imo: vessel.imo,
				spireId: vessel.spireId,
				lineColor: vessel.lineColor
			},
			geometry: {
				type: "LineString",
				coordinates: lineCoords
			}
		});
		$heatmapDataLines.push(coordsLineFeature);
	};


	let updateFilter = () => {
		const splitImos = StringHelper.splitByCommaOrSpace($filterString);
		$resultsTableRowsFiltered = FilterHelper.filterTableDataByIMOList($resultsTableRows, splitImos);
		$resultsTableRowsFiltered = $resultsTableRowsFiltered.map((row) => {
			return {
				imo: row.imo,
				name: row.name,
				mmsi: row.mmsi,
				shipType: row.shipType,
				spireId: row.spireId,
				selected: row.vessel.selected
			};
		});
		let filterSpireFeature = (feature) => {
			const vessel = VesselHistoryStore.vesselGroup.find({
				[VesselProperty.SPIRE_ID]: feature.properties.spireId,
				selected: true
			}, false);
			return vessel !== false;
		}
		//  console.log("updateFilter", $heatmapDataLines);

		if (VesselHistoryStore.vesselGroup.countSelected() === 0) {
			$heatmapDataPointsFiltered = [...$heatmapDataPoints];
			$heatmapDataLinesFiltered = [...$heatmapDataLines];
		}
		else {
			$heatmapDataPointsFiltered = $heatmapDataPoints.filter(filterSpireFeature);
			$heatmapDataLinesFiltered = $heatmapDataLines.filter(filterSpireFeature);
		}
		// console.log("filtered", $heatmapDataPointsFiltered, "original", $heatmapDataPoints)
	};

	// TODO: reset results and clear form inputs separate. Show a clear button when form is in non-default state.
	let clearForm = () => {
		VesselHistoryStore.actions.resetQuery();
		$imommsiTextAreaValue = "";
	};
	let resetForm = () => {
		VesselHistoryStore.actions.resetMeta();
		VesselHistoryStore.actions.resetResults();
		// $imommsiTextAreaValue = "";
		spireIdProgressData = {};
		stopAllAutoContinues();

		updateFilter();
		updateMapWithData();
		if (investigate && investigate.reset) {
			investigate.reset();
		}

		if (investigateMerged && investigateMerged.reset) {
			investigateMerged.reset();
		}
		Analytics.event("reset_form", { category: "Vessel History", username: get(AuthStore.userInfo).username });
	};

	let resetApiRequest = () => {
		VesselHistoryStore.actions.resetMeta();
		VesselHistoryStore.actions.resetResults();

		spireIdProgressData = {};
		stopAllAutoContinues();

		updateMapWithData();
	};
	let updateMapWithData = () => {
		if ($map) {
			VesselHistoryStore.actions.updateMapSources();

			if (investigate && investigate.updateData) {
				investigate.updateData();
			}
			
			if (investigateMerged && investigateMerged.updateData) {
				investigateMerged.updateData();
			}
		}
	}
	VesselHistoryStore.vesselGroup.vessels.subscribe(() => {
		updateFilter();
		updateMapWithData();
	});


	VesselHistoryStore.vesselGroup.timeSliderData.value.subscribe((value) => {
		// console.log("VesselHistoryStore.vesselGroup.timeSliderData.value", value);
		const vessels = get(VesselHistoryStore.vesselGroup.vessels);
		if(vessels){
			updateMapWithData();
		}
	});

	MapStore.meta.initialised.subscribe((initialised)=>{
		if (initialised) {
			const map = MapStore.helpers.getMap();
			map.on("click", MapLayer.VESSEL_HISTORY_SNAPSHOT, (event) => {
				event.preventDefault();

				VesselHistoryStore.vesselGroup.selectSingle(map, event, [MapLayer.VESSEL_HISTORY_SNAPSHOT], [VesselProperty.SPIRE_ID]);
			});
			map.on("click", MapLayer.HEATMAP_POINTS, event => {
				event.preventDefault();
				let features = map.queryRenderedFeatures(event.point, {
					layers: [MapLayer.HEATMAP_POINTS]
				});
				if (features.length) {
					const feature = features[0];
					const featureTimeStamp = feature.properties[VesselProperty.TIMESTAMP]
					if(featureTimeStamp) {
						VesselHistoryStore.vesselGroup.timeSliderData.value.set(moment(new Date(featureTimeStamp)));
					}
				}
			});
		}
	});

	let resultsTableColumns = [
		{
			key: "imo",
			title: "IMO",
			value: v => v.imo,
			sortable: true,
			renderValue: (v, v2) => {
				return v.imo;
			},
			class: v => {
				return v.selected ? "selected" : "";
			},
			headerClass: "imo"
		},
		{
			key: "mmsi",
			title: "MMSI",
			value: v => v.mmsi,
			sortable: true,
			class: v => {
				return v.selected ? "selected" : "";
			},
			headerClass: "mmsi"
		},
		{
			key: "name",
			title: "Name",
			value: v => v.name,
			renderValue: v => "<span title='" + v.name + "'>" + v.name + "</span>",
			sortable: true,
			class: v => {
				return "name " + (v.selected ? "selected" : "");
			},
			headerClass: "name"
		},
		{
			key: "shipType",
			title: "Type",
			value: v => v.shipType,
			renderValue: v => v.shipType,
			sortable: true,
			class: v => {
				return "shipType " + (v.selected ? "selected" : "");
			},
			headerClass: "name"
		}
		//,
		// {
		// 	key: "target",
		// 	title: "",
		// 	value: v => false,
		// 	sortable: false,
		// 	renderValue: v => "<img alt='Focus' src='" + Icon.crosshair.solid + "'/>",
		// 	class: (v) => { return "target" + ((v.selected)?" selected":""); },
		// 	headerClass: "target"
		// }
	];

	let onCellClick = event => {
		const columnKey = event.detail.key;
		const rowData = event.detail.row;

		const imo = rowData.imo;
		const spireId = rowData.spireId;

		if (User.hasFeature(Feature.VESSEL_HISTORY.INVESTIGATE)) {
			const vessel = VesselHistoryStore.vesselGroup.find({[VesselProperty.SPIRE_ID]: spireId});
			//console.log('cell click, vessel', vessel);
			if (vessel) {
				vessel.selected = !vessel.selected;
				VesselHistoryStore.vesselGroup.update();
			}
		}
	};

	let clearSelected = ()=>{
		VesselHistoryStore.vesselGroup.deselectAll();
		updateFilter();
		updateMapWithData();
	};

	let layerChange = event => {
		const targetData = event.target.parentNode.parentNode.parentNode;
		const targetCheckbox = event.target;

		const layer = targetData.dataset.layer;
		const storeKey = targetData.dataset['storekey'];
		const checked = targetCheckbox.checked;

		//console.log('ds', event.target.dataset, 'storeKey', storeKey, 'checked', checked);

		VesselHistoryStore.filters.layers[storeKey].enabled.set(checked);
		MapLayerManager.updateVisibleLayers();
		//MapActions.setFleetViewLayerVisible(layer, checked);

	};
	let inputType = VesselHistoryStore.query.inputType;
	let inputTypeLen = 7;
	const toggleInputType = e => {
		$inputType = e.target.value;
		inputTypeLen = ($inputType === VesselIDType.IMO) ? 7 : 9;
		VesselHistoryStore.helpers.onImoMMSITextareaInputValue($imommsiTextAreaValue);
	};

	let iconMode = AlertsStore.iconMode; // TODO: Global icon mode outside of AlertsStore?
	$: {
		$iconMode;
		const allVessels = get(VesselHistoryStore.vesselGroup.vessels);
		if (allVessels) {
			removeLinesAndPointsForAllVessels();

			allVessels.forEach((vessel) => { 
				vessel.setIconMode($iconMode); 
				addLinesAndPointsForVessel(vessel);
			});
			$lastUpdated = Date.now();
			updateFilter();
			updateMapWithData(); // VesselHistoryStore.actions.updateMapSources();

			
		}
	}

	

	let user = AuthStore.session.user;
	let datePickerDialect = DateDialect.DMY;
	let datePickerStrFormat = "#{F} #{j}, #{Y}";//"#{d}/#{m}/#{Y}"
	$: {
		datePickerDialect = $user.dateDialect;
		console.log("datePickerDialect", datePickerDialect);
		// if (datePickerDialect === DateDialect.MDY) {
		// 	datePickerStrFormat = "#{m}/#{d}/#{Y}"
		// }
	}


	let earliestVHTime = twoYearsAgo;
	$: {
		if ($user.company.vesselHistoryDateRestriction === DateRestriction.NONE) {
			earliestVHTime = moment(Date.parse("2016-01-01T00:00:00")).toDate(); // Arbitrary 5ish years.
		}
		else if ($user.company.vesselHistoryDateRestriction === DateRestriction.FIXED_LENGTH) {
			let vhRestrictSeconds = $user.company.vesselHistoryDateRestrictionValue;
			earliestVHTime = moment(today).subtract(vhRestrictSeconds, "seconds").toDate();
		}
		else if ($user.company.vesselHistoryDateRestriction === DateRestriction.FIXED_DATE) {
			let vhStartDate = $user.company.vesselHistoryDateRestrictionValue;
			earliestVHTime = moment(vhStartDate).toDate();
		}
		console.log("earliestVHTime", earliestVHTime.toISOString());
	}

	////#endregion

	let selectedTogglesByType = VesselHistoryStore.query.limitedInputs;

</script>

<div id='vessel-history-components'>

<MenuItem title={"Query Vessel History"} materialIcon={"query_builder"}>
	<div class="menu-subelement">
		{#if User.hasFeature(Feature.VESSEL_HISTORY.SEARCH_BY_MMSI)}
			<div style="margin-bottom:10px">
				<FormField>
					<Radio on:click={toggleInputType} bind:group={$inputType} value={VesselIDType.IMO} disabled={$state !== LoadState.INIT}/>
					<span slot="label">Use IMOs (7 digit)</span>
				</FormField>
				<FormField>
					<Radio on:click={toggleInputType} bind:group={$inputType} value={VesselIDType.MMSI} disabled={$state !== LoadState.INIT}/>
					<span slot="label">Use MMSIs (9 digit)</span>
				</FormField>
			</div>
		{/if}
		<div class='inputs'>
			{#if User.hasFeature(Feature.VESSEL_HISTORY.RESTRICTED_INPUTS)}

				{#each User.vhRestrictedInputs($inputType) as input}
					<LayerListSwitch label={input} bind:checked={$selectedTogglesByType[$inputType][input]} on:change={VesselHistoryStore.helpers.updateInputsFromToggles} disabled={$state !== LoadState.INIT} />
				{/each}

				{#if User.vhRestrictedInputs($inputType).length === 0}
					<div class='msgbox bg-warning'><p>Vessel Histories are restricted to limited {$inputType.toUpperCase()}s but it has not been configured. Please talk to your Geonius account manager.</p></div>
				{/if}

				<div class='input-actions-container'>
					<button class="btn btn-sml bg-warning" on:click={VesselHistoryStore.helpers.deselectAllInputs} class:bg-info={$state !== LoadState.INIT} disabled={$state !== LoadState.INIT}>Clear Selection</button>
					<button class="btn btn-sml bg-secondary" on:click={VesselHistoryStore.helpers.selectAllInputs} class:bg-info={$state !== LoadState.INIT} disabled={$state !== LoadState.INIT}>Select All</button>
				</div>

			{:else}
				<Textfield fullwidth dense textarea variant="filled"
					bind:value={$imommsiTextAreaValue}
					on:input={(e) => VesselHistoryStore.helpers.onImoMMSITextareaInput(e)}
					on:change={(e) => VesselHistoryStore.helpers.onImoMMSITextareaInput(e)}
					on:focusout={() => VesselHistoryStore.helpers.onImoMMSITextareaLoseFocus()}
					input$on:focusout={() => VesselHistoryStore.helpers.onImoMMSITextareaLoseFocus()}
					input$maximos={100}
					input$maxlength={100 * (inputTypeLen+1)}
					input$aria-controls="helper-text-fullwidth-textarea"
					input$aria-describedby="helper-text-fullwidth-textarea"
					disabled={$state !== LoadState.INIT}
					label={$inputType.toUpperCase() + " numbers"}
					/>
				<HelperText id="helper-text-fullwidth-textarea">Input space/comma separated {$inputType.toUpperCase()}s...<span slot="character-counter"><IMOCounter>0 / 100</IMOCounter></span></HelperText>
			{/if}
		</div>

		{#if $showValidationText && !$imommsiInputValid}
			<Card class="bg-error" padded style="margin-top:10px;">
				<p>
					Please check input. Format or {$inputType.toUpperCase()} number is invalid. Please use comma or space separated {$inputType.toUpperCase()}s only.
				</p>
				<ul>
					{#each $invalidInputsStore as inputNumber}<li>{inputNumber}</li>{/each}
				</ul>
			</Card>
		{/if}
		{#if $imommsiInputLength > MAX_INPUTS}
			<Card class="bg-error" padded style="margin-top:10px">
				<p>Please input no more than 100 {$inputType.toUpperCase()}s</p>
			</Card>
		{/if}

		<Datepicker
			start={earliestVHTime}
			end={$toDateTimeStore}
			format={datePickerStrFormat}
			bind:selected={$fromDateTimeStore}
			bind:formattedSelected={fromFormattedSelected}>
			<Button color="secondary" variant="unelevated" style="width:100%;margin-top:10px;" disabled={$state !== LoadState.INIT}><Label>From: {fromFormattedSelected}</Label></Button>
		</Datepicker>

		<Datepicker
			start={$fromDateTimeStore}
			end={today}
			format={datePickerStrFormat}
			bind:selected={$toDateTimeStore}
			bind:formattedSelected={toFormattedSelected}>
			<Button color="secondary" variant="unelevated" style="width:100%;margin-top:5px;" disabled={$state !== LoadState.INIT}><Label>To: {toFormattedSelected}</Label></Button>
		</Datepicker>

		<!-- <hr /> -->

		<div style="padding-top:10px;padding-bottom:10px;">
			<FormField>
				<Radio bind:group={$downsampling} name="data-downsampling" value={DownsampleRate.DAILY} disabled={$state !== LoadState.INIT}/>
				<span slot="label">One point per day</span>
			</FormField>
			<FormField>
				<Radio id="vessel-history-all-data" bind:group={$downsampling} name="data-downsampling" value={DownsampleRate.NONE} disabled={$imommsiInputLength >= MAX_INPUTS_FOR_ALL || $state !== LoadState.INIT} />
				<span slot="label">All data</span>
			</FormField>
		</div>

		<!-- {#if $imommsiInputLength >= MAX_INPUTS_FOR_ALL}
			<div>
				<label>
					<input
						type="radio"
						name="data-downsampling"
						value={DownsampleRate.DAILY}
						checked="checked" />
					One point per day
				</label>
			</div>
			<div>
				<label>
					<input
						id="vessel-history-all-data"
						disabled
						type="radio"
						name="data-downsampling"
						value={DownsampleRate.NONE} />
					All data
				</label>
			</div>
		{:else}
			<div>
				<label>
					<input
						type="radio"
						name="data-downsampling"
						value={DownsampleRate.DAILY}
						bind:group={$downsampling} />
					One point per day
				</label>
			</div>
			<div>
				<label>
					<input
						id="vessel-history-all-data"
						disabled={$imommsiInputLength >= MAX_INPUTS_FOR_ALL}
						type="radio"
						name="data-downsampling"
						value={DownsampleRate.NONE}
						bind:group={$downsampling} />
					All data
				</label>
			</div>
		{/if} -->

		<!-- <hr /> -->
		<!-- {#if queryIsValid && $state !== LoadState.LOADING}
			<button id="vessel-history-submit"
				on:click={startApiRequest}
				title="Fetching the data could take several minutes">
				Fetch data
			</button>
		{:else}
			<button disabled>Fetch data</button>
		{/if} -->

		<Button
			id="vessel-history-submit"
			title="Fetching the data could take several minutes"
			color="secondary"
			variant="unelevated"
			disabled={!queryIsValid || $state === LoadState.LOADING || $state === LoadState.LOADED}
			style="width:100%"
			on:click={startApiRequestNew} >
			<Label>Fetch data</Label>
		</Button>

		{#if $state === LoadState.LOADED}
			<Button id="vessel-history-reset"
					title="Reset"
					class='bg-error'
					color="secondary"
					variant="unelevated"
					style="width:100%;margin-top:5px;"
					on:click={resetForm}>
				<Label>Reset</Label>
			</Button>
		{/if}

		{#if $error.length > 0 && $state === LoadState.INIT}
			<Card class="bg-error" padded style="margin-top:10px;">
				<p style="font-weight:bold;">{$error}</p>
			</Card>
		{/if}
	</div>
</MenuItem>

{#if showLoadingCard }
	<MenuItem title={"Loading..."} materialIcon={"hourglass_empty"} class="layer-list-component">
		{#if $error.length > 0}
			Error...

		{:else}
			<p>Fetching data... {$progress}%</p>
			<p>This can take several minutes.</p>
			<Spinner absolute/>
		{/if}

		<ul>
			{#each Object.keys(spireIdProgressData) as spireId}
				<li>
					<b>{spireIdProgressData[spireId].vessel.imo}</b>:
					{#if spireIdProgressData[spireId].error.length > 0}
						<span style="color:red">
							Failed<br/>
							Reason: {spireIdProgressData[spireId].error}<br/>

							<!-- {#if get(spireIdProgressData[spireId].autoContinueCounter) > 0} -->
								Auto-continuing in {get(spireIdProgressData[spireId].autoContinueCounter)} seconds...

								<!-- <Button title="Continue" color="secondary" variant="unelevated" on:click={continueApiRequest}><Label>Continue Now</Label></Button>
								<Button title="Reset" class='bg-info' color="secondary" variant="unelevated" on:click={stopAutoContinueCountdown}><Label>Cancel Auto-continue</Label></Button> -->
							<!-- {:else} -->
								<!-- <Button title="Continue" color="secondary" variant="unelevated" on:click={continueApiRequest}><Label>Continue</Label></Button>
								<Button title="Reset" class='bg-info' variant="unelevated" on:click={resetApiRequest}><Label>Reset</Label></Button> -->
							<!-- {/if} -->

							<button on:click={()=>{
								startRequest(spireIdProgressData[spireId]);
							}}>Continue Now</button>
						</span>


					{:else if spireIdProgressData[spireId].loadState === LoadState.INIT}
						Queued
					{:else if spireIdProgressData[spireId].loadState === LoadState.LOADING}
						Loading... ({Math.floor(spireIdProgressData[spireId].loadProgress*100)}%)
					{:else if spireIdProgressData[spireId].loadState === LoadState.LOADED}
						<span style="color:green">Done!</span>
					{/if}
				</li>
			{/each}
		</ul>
	</MenuItem>
{/if}

{#if showResults}
	{#if $resultsTableRows.length === 0}
		<MenuItem title={"Results"} materialIcon={"directions_boat"}>
			<div class="bg-warning warning">No Vessel results. Please try new query parameters.</div>
		</MenuItem>
	{:else}
		{#if User.hasFeature(Feature.TIME_SLIDER.VIEW)}
			<TimeSlider data={timeSliderData} />
				<!-- bind:this={timeSlider}
				value={MapStore.vesselHistoryDateSliderValue}
				valueMin={MapStore.vesselHistoryDateSliderValueMin}
				valueMax={MapStore.vesselHistoryDateSliderValueMax} -->
		{/if}
		<MenuItem title={"Layers"} materialIcon={"layers"} class="layer-list-component">
			<LayerListSwitch
				label={"AIS positions heatmap"}
				data-storekey="heatmap"
				data-layer={MapLayer.HEATMAP}
				checked="{$layerHeatmap}"
				on:change={layerChange}
			/>
			<LayerListSwitch
				label={"AIS positions"}
				data-storekey="positions"
				data-layer={MapLayer.HEATMAP_POINTS}
				checked="{$layerPositions}"
				on:change={layerChange}
			/>
			<LayerListSwitch
				label={"Vessel journeys"}
				data-storekey="journeys"
				data-layer={MapLayer.HEATMAP_LINES}
				checked="{$layerJourneys}"
				on:change={layerChange}
			/>
			<LayerListSwitch
				label={"Vessels"}
				data-storekey="vessels"
				data-layer={MapLayer.VESSEL_HISTORY_SNAPSHOT}
				checked="{$layerVessels}"
				on:change={layerChange}
			/>
		</MenuItem>

		<MenuItem title={"Results"} materialIcon={"directions_boat"}>
			{#if User.hasFeature(Feature.VESSEL_HISTORY.INVESTIGATE)}
				<Textfield fullwidth dense variant="filled" bind:value={$filterString} on:keyup={updateFilter} label="Filter by IMOs..."/>
			{/if}
			<div class="selection-list-element">
				<div class="alert-list-content mdc-elevation--z2" style="height:auto;">
					<MySvelteTable
						on:clickCell={onCellClick}
						rows={$resultsTableRowsFiltered}
						columns={resultsTableColumns} />
				</div>

				{#if User.hasFeature(Feature.VESSEL_HISTORY.INVESTIGATE)}
					<!-- <button class='btn-clear bg-error' on:click={clearSelected} >Clear Selection</button> -->
					<Button title="Clear Selection" class='bg-error' color="secondary" variant="unelevated" style="width:100%;" on:click={clearSelected}><Label>Clear Selected</Label></Button>
				{/if}
			</div>
		</MenuItem>

		<DownloadResultsButton />

		{#if User.hasFeature(Feature.VESSEL_HISTORY.INVESTIGATE) && $downsampling === DownsampleRate.NONE }
			<InvestigateDataGaps bind:this={investigate} bind:dataPoints={$heatmapDataPointsFiltered} bind:layer={MapLayer.HIGHLIGHT_LINES} />
		{/if}
		
		{#if User.hasFeature(Feature.VESSEL_HISTORY.INVESTIGATE) && $downsampling === DownsampleRate.NONE }
			<InvestigateMergedPoints bind:this={investigateMerged} bind:dataPoints={$mergedPoints} />
		{/if}

		<HeatmapKey />
		<VesselKeyComponent defaultModeName="Default" disabled={$state === LoadState.LOADING}/>
	{/if}

{/if}


</div>
